﻿/*************************** MODAL HANDLER START *****************************/
(function () {
    const mdlPopup = document.getElementById('mdl-popup');
    const showPopupBtns = document.querySelectorAll('[data-popup-toggle]');
    let lastFocused = null;

    if (showPopupBtns.length) {
        showPopupBtns.forEach(btn => btn.addEventListener('click', onShowClick));
    }
    if (mdlPopup) {
        mdlPopup.addEventListener('click', onOverlayClick);
        document.addEventListener('keydown', onKeydownEsc);
    }

    function onShowClick(e) {
        e.preventDefault();

        const trigger = e.currentTarget || e.target.closest('[data-popup-toggle]');
        if (!trigger) return;

        const holder = trigger.closest('[data-popup-id]');
        const popupId = holder ? holder.dataset.popupId : null;
        if (!popupId || !mdlPopup) return;

        const popupContent = mdlPopup.querySelector(`[data-popup="${popupId}"]`);
        const popupContainer = mdlPopup.querySelector('.popup-container');
        if (!popupContent || !popupContainer) return;

        popupContainer.className = 'popup-container ' + (trigger.dataset.popupSize || 'default');

        mdlPopup.removeAttribute('hidden');
        mdlPopup.classList.add('visible');
        popupContent.classList.add('visible');
        document.documentElement.classList.add('scroll-lock');
        document.body.classList.add('scroll-lock');

        mdlPopup.setAttribute('aria-hidden', 'false');
        lastFocused = document.activeElement;
        const focusable = popupContent.querySelector('button, a[href], input, [tabindex]:not([tabindex="-1"])');
        if (focusable) try { focusable.focus(); } catch (_) { }
    }

    function onOverlayClick(e) {
        if (e.target.id === 'mdl-popup' || e.target.classList.contains('mdl-btn-close')) {
            hideModal();
        }
    }

    function onKeydownEsc(e) {
        if (e.key === 'Escape' && mdlPopup && mdlPopup.classList.contains('visible')) {
            hideModal();
        }
    }

    function hideModal() {
        if (!mdlPopup) return;
        const visibleContent = mdlPopup.querySelector('.popup-content.visible');
        if (visibleContent) visibleContent.classList.remove('visible');

        mdlPopup.classList.remove('visible');
        mdlPopup.setAttribute('hidden', '');
        mdlPopup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('scroll-lock');
        document.body.classList.remove('scroll-lock');

        if (lastFocused) try { lastFocused.focus(); } catch (_) { }
    }

    window.hideMdlPopup = hideModal;

    window.showDefaultPopup = function (popupContentId, popupMessage) {
        if (!mdlPopup) return;
        const content = mdlPopup.querySelector(`[data-popup="${popupContentId}"]`);
        if (!content) return;

        const msg = content.querySelector('.popup-message');
        if (msg) msg.innerText = popupMessage;

        mdlPopup.removeAttribute('hidden');
        mdlPopup.classList.add('visible');
        content.classList.add('visible');
        document.documentElement.classList.add('scroll-lock');
        document.body.classList.add('scroll-lock');
        mdlPopup.setAttribute('aria-hidden', 'false');
    };

    // --- Guard mod at "default"-popuppen åbner for tidligt ved pageload ---
    (function () {
        const PAGE_LOADED_AT = Date.now();
        const _origShow = window.showDefaultPopup;

        window.showDefaultPopup = function (popupContentId, popupMessage, opts) {
            if (popupContentId === 'default' && !(opts && opts.allowEarly)) {
                const tooEarly = (Date.now() - PAGE_LOADED_AT) < 800;
                if (tooEarly) {
                    console.warn('[popup] blocked early default open', { popupMessage });
                    return;
                }
            }

            const fn = _origShow || function fallback(id, msg) {
                const mdl = document.getElementById('mdl-popup');
                if (!mdl) return;
                const content = mdl.querySelector(`[data-popup="${id}"]`);
                if (!content) return;

                if (typeof msg === 'string') {
                    const msgEl = content.querySelector('.popup-message');
                    if (msgEl) msgEl.innerText = msg;
                }

                mdl.removeAttribute('hidden');
                mdl.classList.add('visible');
                content.classList.add('visible');
                document.documentElement.classList.add('scroll-lock');
                document.body.classList.add('scroll-lock');
                mdl.setAttribute('aria-hidden', 'false');
            };

            return fn(popupContentId, popupMessage, opts);
        };

        document.addEventListener('DOMContentLoaded', () => {
            const mdl = document.getElementById('mdl-popup');
            if (!mdl) return;
            const def = mdl.querySelector('[data-popup="default"].visible');
            if (def && (Date.now() - PAGE_LOADED_AT) < 800) {
                def.classList.remove('visible');
                mdl.classList.remove('visible');
                mdl.setAttribute('hidden', '');
                mdl.setAttribute('aria-hidden', 'true');
                document.documentElement.classList.remove('scroll-lock');
                document.body.classList.remove('scroll-lock');
                console.warn('[popup] removed early-opened default popup');
            }
        });
    })();

})();
/*************************** MODAL HANDLER END *****************************/
